import { useState } from 'react';
import UnfollowModal from './UnfollowModal';
import { IDataroomListItem } from '../../../../domain/vo/DataroomListItem';

export default function useUnfollowModal() {
  const [dataroomItem, setDataroomItem] = useState<IDataroomListItem | null>(null);

  const showUnfollowModal = (item: IDataroomListItem) => {
    setDataroomItem(item);
  };

  const hideUnfollowModal = () => {
    setDataroomItem(null);
  };

  return {
    UnfollowModal,
    dataroomItem,
    showUnfollowModal,
    hideUnfollowModal,
  };
}
